// @ts-nocheck
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
Vue.config.productionTip = false;
var timings = new Map();
function logModuleUsage(moduleName) {
    var startTime = timings.get(moduleName);
    if (!startTime)
        return;
    var now = new Date();
    var usageTime = (now.getTime() - startTime.getTime()) / 1000;
    if (usageTime > 5) {
        fetch('/aims/api/logModuleUsage', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                module: moduleName,
                timeSpent: (now.getTime() - startTime.getTime()) / 1000,
            }),
        });
    }
}
router.beforeEach(function (to, from, next) {
    var now = new Date();
    if (to.name) {
        timings.set(to.name, now);
    }
    next();
});
router.afterEach(function (_, from) {
    if (from.name && timings.has(from.name)) {
        logModuleUsage(from.name);
    }
});
new Vue({
    router: router,
    store: store,
    vuetify: vuetify,
    render: function (h) { return h(App); },
    mounted: function () {
        var _this = this;
        window.onbeforeunload = function () {
            if (_this.$router.currentRoute.name && timings.has(_this.$router.currentRoute.name)) {
                logModuleUsage(_this.$router.currentRoute.name);
            }
        };
    },
}).$mount('#app');
